import cn from 'classnames'
import Link from 'next/link'
import React, { memo } from 'react'
import { usePhasesForSubTopicQuery } from 'src/graphql/generated/hooks'

import { PhasePanel } from './PhasePanel'

interface PhasesSectionProps {
  topicName?: string
  subTopicName?: string
  topicSlug?: string
  subTopicSlug?: string
  viewAllUrl: string
}

export const PhasesSection: React.FC<PhasesSectionProps> = memo(
  ({ topicName, subTopicName, topicSlug, subTopicSlug, viewAllUrl }) => {
    const { data } = usePhasesForSubTopicQuery()
    const panels = (data?.phases?.data || []).map((phase) => {
      const phaseId = phase.id!
      let links = []
      if (phase.attributes?.title === 'Explore') {
        links = [
          {
            label: 'View Full Directory',
            href: subTopicSlug
              ? `/topics/${topicSlug}/${subTopicSlug}/?tab=directory`
              : `/topics/${topicSlug}/?tab=directory`,
          },
          {
            label: 'View all Exploration Content',
            href: subTopicSlug
              ? `/topics/${topicSlug}/${subTopicSlug}/?tab=content&phase=${phaseId}`
              : `/topics/${topicSlug}/?tab=content&phase=${phaseId}`,
          },
        ]
      } else {
        links = [
          {
            label: `View all ${phase.attributes?.title} content`,
            href: subTopicSlug
              ? `/topics/${topicSlug}/${subTopicSlug}/?tab=content&phase=${phaseId}`
              : `/topics/${topicSlug}/?tab=content&phase=${phaseId}`,
          },
        ]
      }

      return {
        title: phase.attributes?.title || '',
        content: phase.attributes?.description || '',
        links,
      }
    })

    return (
      <div className={cn('w-full px-5 sm:px-0 flex flex-row justify-center bg-white')}>
        <div className="max-w-screen-xl w-full">
          <p className="font-bold font-secondary text-[24px] w-full text-left mt-10 leading-[35px] text-[#222222]">
            Resources About {subTopicName || topicName}
          </p>
          <p className="font-primary font-regular text-[18px] leading-[22px] text-gray w-full text-left">
            Our guides are written by industry experts
          </p>
          <div className={`w-full mt-[30px] grid md:grid-flow-row grid-cols-${panels.length} gap-12`}>
            {panels.map((item, index) => (
              <PhasePanel key={index} title={item.title} content={item.content} links={item.links} />
            ))}
          </div>
          <Link
            href={viewAllUrl}
            className="font-bold w-full text-center mt-10 cursor-pointer text-textdark underline underline-offset-4"
          >
            View All Content
          </Link>
        </div>
      </div>
    )
  },
)
